import { BADGE_ART, BADGE_INFO, BADGE_LOOK } from '@/lib/achieve'
import { PlusMark } from '../PlusMark'
import { Tooltip } from '../Tooltip'
import styles from './BadgeIcon.module.css'

/** Картинка значка нужного размера: Плюс — фирменным знаком, остальные — из ChatGPT, новый — иконкой на плитке. */
function BadgeArt({ id, size }: { id: string; size: number }) {
  if (id === 'plus') return <PlusMark size={size} label={null} className={styles.art} />
  if (BADGE_ART.has(id)) {
    return (
      <img
        className={styles.art}
        src={`/badges/${id}-${size > 48 ? 128 : 64}.webp`}
        srcSet={`/badges/${id}-32.webp 32w, /badges/${id}-64.webp 64w, /badges/${id}-128.webp 128w`}
        sizes={`${size}px`}
        width={size}
        height={size}
        alt=""
        draggable={false}
      />
    )
  }
  const look = BADGE_LOOK[id]
  if (!look) return null
  const Icon = look.icon
  return (
    <span className={styles.tile} style={{ width: size, height: size, background: look.bg, color: look.fg }}>
      <Icon size={Math.round(size * 0.62)} aria-hidden="true" />
    </span>
  )
}

/**
 * Значок профиля с подсказкой, как в Discord: наведение показывает значок крупно, название
 * и за что он. Картинки — docs/badges; новый значок без картинки рисуется иконкой на плитке.
 */
export function BadgeIcon({ id, name, size = 24 }: { id: string; name: string; size?: number }) {
  if (id !== 'plus' && !BADGE_ART.has(id) && !BADGE_LOOK[id]) return null
  const info = BADGE_INFO[id]
  return (
    <Tooltip
      label={name}
      content={
        <span className={styles.tip}>
          <BadgeArt id={id} size={56} />
          <span className={styles.tipName}>{name}</span>
          {info ? <span className={styles.tipText}>{info}</span> : null}
        </span>
      }
    >
      <BadgeArt id={id} size={size} />
    </Tooltip>
  )
}
